<template>
<div id="vendors">

    <div class="btn-header">
        <v-row class="defaultgroup" :class="checkedItems.length||bulkSelectAll?'transform-hideview':''">
            <v-col class="pa-0" cols="3">
                <v-text-field clearable placeholder="Search by name, code, city ..." @input="onSearch" outlined hide-details v-model="search"/>
            </v-col><v-spacer/>
            <v-btn large class="primary text-capitalize elevation-0 mt-2" @click="formDialog=true">Add Vendor</v-btn>
        </v-row>
        <BulkActionVendor :filter="bulkFilter" @onCancelSelect="onChangeSelectAll($event)" @showToast="toaster=$event"
                              class="checkedgroup" :class="checkedItems.length||bulkSelectAll?'transform-showview':''"/>
    </div>

    <v-data-table :headers="headers" :items="vendors" :server-items-length="vendorsCount" fixed-header height="calc(100vh - 304px)"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :options.sync="options" @update:page="$vuetify.goTo(0)"
                  @update:options="onUpdateOptions" :footer-props="{itemsPerPageOptions:rowsPerPageItems}" class="vendor-table">
        <template v-slot:no-data>No Vendor Available</template>
        <template v-slot:no-results>No Vendor Available</template>
        <template v-slot:header.checkbox="{}">
            <v-checkbox v-model="bulkSelectAll" @click.stop="onChangeSelectAll(uncheckedItems.length>0||!bulkSelectAll)"
                        :indeterminate="!!(checkedItems.length||uncheckedItems.length)"/>
        </template>
        <template v-slot:body="{ items }">
         <tbody>
           <tr v-for="(item,index) in items" :key="index" :class="item.checked?'checked-row':''">
             <td>
                 <v-checkbox v-model="item.checked" :class="item.checked?'check-icon checked':'check-icon'" @click.stop="onCheck(item)"/>
             </td>
             <td>
               <v-avatar tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click="openGallery([{path: item.profileImage, type: 'IMAGE'}])" class="mr-6 my-3" title="View Image">
                <v-img v-if="item.profileImage" :src="imgWpx(item.profileImage, 200)" :alt="item.name" @error="item.profileImage = null">
                    <template v-slot:placeholder>
                        <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"/>
                    </template>
                </v-img>
                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
               </v-avatar>
               <span class="v-name ellipsis">
                   <span :title="item.name">{{ item.name}}</span><br>
                   <span :title="item.vendorCode" class="f-12 grey--text text--darken-1">{{item.vendorCode}}</span>
               </span>
             </td>
            <td>{{item.city || '-'}}</td>
            <td>
                <v-tooltip right content-class="tooltip">
                    <template v-slot:activator="{ on }"><span v-on="on">{{item.accountName || '-'}}</span></template>
                    <ul class="tooltip-content">
                        <li>Account Name: {{item.accountName || '-'}}</li> <li>Account Number: {{item.accountNumber || '-'}}</li>
                        <li>Bank Name: {{item.bankName || '-'}}</li> <li>IFSC Code: {{item.ifscCode || '-'}}</li>
                    </ul>
                </v-tooltip>
            </td>
            <td>{{item.transportation || '-'}}</td>
            <td>{{moment(item.created_at).format('DD MMM YY hh:mm A')}}</td>
            <td>
                <v-menu nudge-bottom="25">
                  <template v-slot:activator="{ on:menu }">
                      <v-btn small icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list dense>
                      <v-list-item @click="onEditVendor(item)"><v-list-item-title>Edit</v-list-item-title></v-list-item>
                      <v-list-item @click="onDeleteVendor(item)"><v-list-item-title>Delete</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
            </td>
           </tr>
         </tbody>
        </template>
    </v-data-table>

    <VendorForm :dialog.sync="formDialog" :id.sync="vendorId"/>
    <Snackbar :toaster="toaster"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <gallery id="gallery-vendors" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../../Constants/Constants";
import moment from 'moment';
import gallery from '../../../mixins/gallery';
import updateRecord from '../../../mixins/updateRecord';
import {debounce} from "lodash";
import Snackbar from "../../../components/Common/Snackbar";
import VendorForm from "./VendorForm";
import {SUBSCRIBE_VENDORS, SUBSCRIBE_VENDORS_COUNT} from "../../../graphql/subscriptions/Vendors";
import ConfirmationDialog from "../../../components/Common/ConfirmationDialog";
import BulkActionVendor from "./BulkActionVendor";
import Vue from 'vue';
let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};
export default {
    name: "Vendors",
    components: {BulkActionVendor, ConfirmationDialog, VendorForm, Snackbar},
    mixins: [gallery, updateRecord],
    apollo: {
        $subscribe: {
            vendorsCount:{
                query: SUBSCRIBE_VENDORS_COUNT,
                variables () { return { search: this.vendorSearch }},
                result ({ data }) { this.vendorsCount = data.vendorsCount.aggregate.count },
            },
            Vendors:{
                query: SUBSCRIBE_VENDORS,
                variables () { return {
                    search: this.vendorSearch, offset: this.options.offset, limit: this.options.limit,
                    orderBy: this.prepareSortObject(this.sortBy, this.sortDesc)
                }},
                result ({ data }) { this.vendors = data.Vendors; this.afterFetchingVendors() },
            },
        }
    },
    data(){
        return{
            Constants: Constants,
            moment: moment,
            user: JSON.parse(localStorage.user),
            headers: [
                {text: '', value: 'checkbox', width: 10, sortable:false},
               /* {text: 'VENDOR IMAGE', value: 'image', sortable:false},*/ {text: 'VENDOR NAME', value: 'name', width:370},
                /*{text: 'VENDOR CODE', value: 'vendorCode'},*/ {text: 'CITY', value: 'city'},
                {text: 'BANK DETAILS', value: 'bankDetails', sortable: false}, {text: 'TRANSPORTATION', value: 'transportation'},
                {text: 'CREATED ON', value: 'created_at'}, { text: 'ACTION', value: 'action', sortable:false }
            ],
            vendors: [],
            vendorsCount: 0,
            options: {...options}, rowsPerPageItems: [25, 50, 100, -1],
            search: '', vendorSearch: '%%',
            sortBy: ['name'], sortDesc: [false],
            formDialog: false,
            vendorId: null,
            toaster: {enable: false},
            confirm: {enable: false},
          /* ----- Bulk Action ----- */
            checkedItems: [],
            uncheckedItems: [],
            bulkSelectAll: false,
          /* -------x-------x------- */
        }
    },
    computed:{
        bulkFilter(){
            let variables = JSON.parse(this.$apollo.subscriptions.vendorsCount.previousVariablesJson);
            return  {ids: this.bulkSelectAll?'ALL':this.checkedItems, uncheckedIds:this.uncheckedItems, allCount:this.vendorsCount, variables};
        },
    },
    methods:{
        afterFetchingVendors(){
            if(this.bulkSelectAll) this.vendors.forEach(v => this.uncheckedItems.includes(v.id) || Vue.set(v, 'checked', true));
            else if(this.checkedItems.length) this.vendors.forEach(v => this.checkedItems.includes(v.id) && Vue.set(v, 'checked', true));
        },
        onCheck(row){
            Vue.set(row, 'checked', !row.checked);
            if(row.checked && this.bulkSelectAll) this.uncheckedItems.splice(this.uncheckedItems.indexOf(row.id), 1);
            else if(!row.checked && this.bulkSelectAll) this.uncheckedItems.push(row.id);
            else if(row.checked  && !this.bulkSelectAll) this.checkedItems.push(row.id);
            else if(!row.checked && !this.bulkSelectAll)this.checkedItems.splice(this.checkedItems.indexOf(row.id), 1);
            if(this.uncheckedItems.length === this.bulkFilter.allCount) this.onChangeSelectAll(false)
            else if(this.checkedItems.length === this.bulkFilter.allCount) this.onChangeSelectAll(true)
            //this.bulkSelectAll = false                                 /* Reset value */
        },
        onChangeSelectAll(value){
            this.bulkSelectAll = value;
            this.vendors.forEach(v => Vue.set(v, 'checked', value));
            /*if(value) this.checkedItems = this.customers.map(c => c.id)*/
            this.checkedItems = [];                                         /* Reset value */
            this.uncheckedItems = [];                                       /* Reset value */
        },
        prepareSortObject([sortBy], [order]) {
            order = order ? 'desc' : 'asc';
            if (['created_at', 'name', 'vendorCode', 'city', 'transportation'].includes(sortBy)) return {[sortBy]: order};
            return null
        },
        onEditVendor(row){
            this.vendorId = row.id;
            this.formDialog = true;
        },
        onDeleteVendor(row){
            this.confirm = {enable:true, message:'Are you sure want to delete Vendor?',
                row, method:this.softDeleteVendor, closeMethod:this.closeConfirmPopup};
        },
        async softDeleteVendor(){
            let obj = {deleted_at:moment().format(), updatedBy:this.user.id};
            await this.updateRecord(this.confirm.row.id, obj, 'Vendors');
            this.toaster = {color:'green', enable:true, message: `Vendor deleted Successfully`};
            this.closeConfirmPopup();
        },
        closeConfirmPopup(){
            this.confirm = {enable: false};
        },
        onUpdateOptions(val){
            if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                this.options.limit = this.vendorsCount;                    //assign total count
                this.options.offset = 0
            }else{
                this.options.limit = val.itemsPerPage;
                this.options.offset = (val.page -1) * val.itemsPerPage;
            }
        },
        onSearch: debounce(function(val){
            this.vendorSearch = val?('%'+val+'%'):'%%'
            this.options = {...options}             //on search, reset page options
        }, 500),
    }
}
</script>

<style scoped>
#vendors{
    padding: 12px;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.v-name{
    display: inline-block;
    vertical-align: middle;
    width: 250px;
    max-width: 250px;
}
.tooltip{
    background-color:#fff;
    color: #000;
}
.tooltip-content li{
    font-size: 18px;
    padding: 4px 0;
}
.vendor-table{
    margin: -20px 0 0 0;
}
/deep/ .vendor-table tbody tr .check-icon .v-icon{
    opacity: 0.2;
}
/deep/ .vendor-table tbody tr .checked .v-icon{
    opacity: unset;
}
/deep/ .vendor-table tbody tr:hover .check-icon .v-icon{
    opacity: unset;
}
/deep/ .vendor-table tbody tr.checked-row{
    background: #eff2f5;
}
/* ---- Bulk Action Styles ---- */
.btn-header{
    /*height: 86px;*/
    overflow: hidden;
    padding: 0px 20px 0px 20px;
}
.btn-header .defaultgroup{
    transform: translateY(0);
    transition: .4s cubic-bezier(.55,.06,.68,.19);
}
.btn-header .checkedgroup{
    transform: translateY(110%);
    transition: .4s cubic-bezier(.55,.06,.68,.19);
}
.transform-hideview{                   /* To hide defaultgroup */
    transform: translateY(-190%) !important;
}
.transform-showview{                   /* To show checkedgroup */
    transform: translateY(-100%) !important;
}
/* ---------x---------x-------- */
</style>